(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3767],{

/***/ 87546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ PhoneIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



function PhoneIcon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: props.size || 21.111,
        height: props.size || 21.111,
        viewBox: "0 0 21.111 21.111"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M19.417 13.857a11.986 11.986 0 01-3.764-.6 1.721 1.721 0 00-1.673.353l-2.374 1.79a13.118 13.118 0 01-5.9-5.9l1.741-2.307a1.706 1.706 0 00.42-1.729 12 12 0 01-.6-3.77A1.7 1.7 0 005.571 0H1.694A1.7 1.7 0 000 1.694a19.439 19.439 0 0019.417 19.417 1.7 1.7 0 001.694-1.694v-3.866a1.7 1.7 0 00-1.694-1.694z",
            fill: props.color
        })
    }));
}


/***/ }),

/***/ 93992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DigitalShowroomAds_ReasonModalHOC; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/utils/useClosePopupFromOutsideClick.js

function useClosePopupFromOutsideClick(referenceToDomElement, toggleClose, props) {
    (0,react.useEffect)(function() {
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    var handleClickOutside = function(e) {
        var ref;
        if (!((ref = e.composedPath()) === null || ref === void 0 ? void 0 : ref.includes(referenceToDomElement.current))) {
            e.stopPropagation();
            toggleClose(props === null || props === void 0 ? void 0 : props.id, props === null || props === void 0 ? void 0 : props.toggleStatus);
        }
    };
}
/* harmony default export */ var utils_useClosePopupFromOutsideClick = (useClosePopupFromOutsideClick);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
;// CONCATENATED MODULE: ./src/components/DesignSystem/DigitalShowroomAds/ReasonModal.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 0;\n  width: 20px;\n  margin-left: ",
        "rem;\n  transform: rotateZ(180deg);\n  margin-top: ",
        "rem;\n  box-shadow: 0px -6px 12px 2px rgb(0 0 0 / 30%);\n  ",
        ";\n\n  &:before {\n    content: '';\n    border-top: 10px solid white;\n    border-right: 10px solid transparent;\n    border-left: 10px solid transparent;\n    border-bottom: 10px solid transparent;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var PointingArrow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "PointingArrow",
    componentId: "sc-6444d3ae-0"
})(_templateObject(), function(props) {
    return props.ml || 0;
}, function(props) {
    return props.mt || 0;
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.translateX) && (props === null || props === void 0 ? void 0 : props.translateY) && "transform : translate(".concat(props === null || props === void 0 ? void 0 : props.translateX, "rem , ").concat(props === null || props === void 0 ? void 0 : props.translateY, "rem) rotate(180deg)");
});

;// CONCATENATED MODULE: ./src/components/DesignSystem/DigitalShowroomAds/ReasonModalHOC.js





function ReasonModalHOC(props) {
    var elementReferenceForOutsideClick = (0,react.useRef)();
    var closePopupForParticularId = {
        id: props.id,
        toggleStatus: false
    };
    utils_useClosePopupFromOutsideClick(elementReferenceForOutsideClick, props.toggleAdReasonModal, closePopupForParticularId);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PointingArrow, {
                ml: props.ml,
                translateX: props.translateX,
                translateY: props.translateY,
                mt: props.mt
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    zIndex: 1
                },
                ref: elementReferenceForOutsideClick,
                className: props.class,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(props.reasonModal, {})
            })
        ]
    });
}
/* harmony default export */ var DigitalShowroomAds_ReasonModalHOC = (ReasonModalHOC);


/***/ }),

/***/ 13767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Footer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Footers/Footer/Footer.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  width: 100%;\n  border-top: 1px solid #e2e2e2;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  width: 100%;\n  flex: 1 1 auto;\n  margin: 0 auto;\n\n  @media screen and (max-width: 766px) {\n    display: none;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin: 0 auto;\n  padding: ",
        ";\n  width: 100%;\n  justify-content: space-between;\n  max-width: ",
        ";\n\n  & > div {\n    display: block;\n    ",
        "\n  }\n\n  & > div::nth-of-type(1),\n  & > div::nth-of-type(3) {\n    flex-grow: 2;\n    flex-shrink: 2;\n  }\n\n  & > div::nth-of-type(2) {\n    flex-grow: 1;\n    flex-shrink: 1;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  position: relative;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  @media screen and (min-width: 767px) {\n    margin: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: 100%;\n  width: 100%;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-bottom: 20px;\n\n  @media screen and (min-width: 767px) {\n    align-items: center;\n  }\n\n  @media screen and (max-width: 766px) {\n    flex-direction: column;\n    gap: 20px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  object-position: center center;\n  object-fit: cover;\n\n  & > img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  @media screen and (min-width: 767px) {\n    margin-right: 15px;\n    flex: 0 0 80px;\n    width: 80px;\n    height: 80px;\n  }\n\n  @media screen and (max-width: 766px) {\n    flex: 0 0 55px;\n    width: 55px;\n    height: 55px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  flex: 1;\n  color: #000000;\n  text-transform: uppercase;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  @media screen and (min-width: 767px) {\n    font-size: 24px;\n    -webkit-line-clamp: 3;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 21px;\n    -webkit-line-clamp: 4;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (max-width: 766px) {\n    margin-bottom: 20px;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  letter-spacing: 0.37px;\n  color: #000000;\n  margin: 0;\n\n  @media screen and (min-width: 767px) {\n    font-size: 16px;\n    margin-bottom: 10px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 11px;\n    margin-bottom: 5px;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #747373;\n  letter-spacing: 1.4px;\n  max-width: 300px;\n  margin: 0;\n  word-break: break-word;\n\n  ",
        "\n\n  ",
        "\n\n  @media screen and (min-width: 767px) {\n    font-size: 14px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 12px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 11px;\n  font-weight: 600;\n  position: relative;\n  display: inline-block;\n  color: #2a2a2a;\n  line-height: 1.4em;\n  cursor: pointer;\n  margin-top: 5px;\n\n  &:hover {\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  @media screen and (min-width: 767px) {\n    border-top: 1px solid #bebebe;\n    padding: 30px 0;\n  }\n\n  @media screen and (max-width: 766px) {\n    flex-direction: column;\n    padding: 10px 0;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  color: #bebebe;\n  padding: 10px;\n\n  & > a,\n  & > a:visited,\n  & > a:active,\n  & > a:visited {\n    color: inherit;\n  }\n\n  & > a:not(:hover) {\n    text-decoration: none;\n  }\n\n  @media screen and (min-width: 767px) {\n    font-size: 12px;\n    &:first-child {\n      border-right: 1.5px solid #bebebe;\n    }\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 11px;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  width: 5px;\n  height: 5px;\n  position: relative;\n  background-color: #747373;\n  margin-left: 10px;\n  margin-right: 10px;\n  border-radius: 50%;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n  margin: 0 0 20px;\n  ",
        "\n\n  & > a,\n  & > a:visited,\n  & > a:active,\n  & > a:visited {\n    color: inherit;\n    text-decoration: none;\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 0 0 auto;\n  width: fit-content;\n  position: relative;\n  padding: 6px 8px;\n  border-radius: ",
        ";\n  border-style: solid;\n  border-width: 0.4px;\n  border-color: ",
        ";\n  cursor: pointer;\n\n  & > a {\n    display: flex;\n    text-decoration: none;\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  display: inline-block;\n  margin-left: 10px;\n\n  @media screen and (min-width: 767px) {\n    font-size: 14px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 12px;\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n\n  @media screen and (min-width: 767px) {\n    &:not(:first-child) {\n      margin-left: 10px;\n    }\n  }\n\n  @media screen and (max-width: 766px) {\n    margin-left: 10px;\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  text-transform: capitalize;\n\n  @media screen and (max-width: 766px) {\n    font-size: 9px;\n  }\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  @media screen and (min-width: 767px) {\n    display: none;\n  }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 30px 20px 0px;\n  flex-direction: column;\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}

var FooterContainer = styled_components_browser_esm/* default.footer.withConfig */.ZP.footer.withConfig({
    displayName: "FooterContainer",
    componentId: "sc-8c9af499-0"
})(_templateObject());
var FooterDesktopContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "FooterDesktopContainer",
    componentId: "sc-8c9af499-1"
})(_templateObject1());
var FooterDesktopMain = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "FooterDesktopMain",
    componentId: "sc-8c9af499-2"
})(_templateObject2(), function(param) {
    var noAddress = param.noAddress;
    return noAddress ? "3rem 2rem 1.5rem" : "3rem 1rem 1.5rem";
}, function(param) {
    var noAddress = param.noAddress;
    return noAddress ? "780px" : "1200px";
}, function(param) {
    var noAddress = param.noAddress;
    return noAddress ? "\n      flex: 0 0 auto\n    " : "width: 100%;";
});
var StoreDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "StoreDescription",
    componentId: "sc-8c9af499-3"
})(_templateObject3());
var StoreDetails = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "StoreDetails",
    componentId: "sc-8c9af499-4"
})(_templateObject4(), function(param) {
    var noAddress = param.noAddress;
    return noAddress ? "0 20px" : "0";
});
var StoreMapComp = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "StoreMapComp",
    componentId: "sc-8c9af499-5"
})(_templateObject5());
var StoreNameImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "StoreNameImage",
    componentId: "sc-8c9af499-6"
})(_templateObject6());
var StoreImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "StoreImage",
    componentId: "sc-8c9af499-7"
})(_templateObject7());
var StoreName = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "StoreName",
    componentId: "sc-8c9af499-8"
})(_templateObject8());
var StoreAboutUs = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "StoreAboutUs",
    componentId: "sc-8c9af499-9"
})(_templateObject9());
var FooterLabel = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "FooterLabel",
    componentId: "sc-8c9af499-10"
})(_templateObject10());
var FooterPara = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "FooterPara",
    componentId: "sc-8c9af499-11"
})(_templateObject11(), function(props) {
    return props.textSelection && "\n    -webkit-touch-callout: text;\n    -webkit-user-select: text;\n    -khtml-user-select: text;\n    -moz-user-select: text;\n    -ms-user-select: text;\n    user-select: text;  \n  ";
}, function(props) {
    return props.needLineClip && "\n    display: -webkit-box;\n    -webkit-line-clamp: 5;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  ";
});
var ViewMoreText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "ViewMoreText",
    componentId: "sc-8c9af499-12"
})(_templateObject12());
var FooterTrademarkComponent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FooterTrademarkComponent",
    componentId: "sc-8c9af499-13"
})(_templateObject13());
var FooterTrademark = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "FooterTrademark",
    componentId: "sc-8c9af499-14"
})(_templateObject14());
var Circle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "Circle",
    componentId: "sc-8c9af499-15"
})(_templateObject15());
var Section = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "Section",
    componentId: "sc-8c9af499-16"
})(_templateObject16(), function(props) {
    return props.display || "block";
}, function(props) {
    return props.display && "\n    margin: 0; \n    justify-content: center;\n    align-items: center;\n    padding: 20px;\n    border-bottom: 1px solid #707070;\n  ";
});
var FooterButton = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "FooterButton",
    componentId: "sc-8c9af499-17"
})(_templateObject17(), function(props) {
    return props.theme.roundness || "14px";
}, function(props) {
    return props.color;
});
var PhoneNumber = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "PhoneNumber",
    componentId: "sc-8c9af499-18"
})(_templateObject18(), function(props) {
    return props.color;
});
var PaymentRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "PaymentRow",
    componentId: "sc-8c9af499-19"
})(_templateObject19());
var PaymentOption = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "PaymentOption",
    componentId: "sc-8c9af499-20"
})(_templateObject20());
var PaymentCash = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "PaymentCash",
    componentId: "sc-8c9af499-21"
})(_templateObject21());
var FooterMobileContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "FooterMobileContainer",
    componentId: "sc-8c9af499-22"
})(_templateObject22());
var FooterMobileMain = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FooterMobileMain",
    componentId: "sc-8c9af499-23"
})(_templateObject23());

// EXTERNAL MODULE: ./src/assets/svgExports/PhoneIcon.js
var PhoneIcon = __webpack_require__(87546);
// EXTERNAL MODULE: ./src/assets/svgExports/InfoIcon.js
var InfoIcon = __webpack_require__(67313);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/utils/deviceInfo.js
var deviceInfo = __webpack_require__(90864);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(44541);
// EXTERNAL MODULE: ./src/components/DesignSystem/SubscriberInput/index.js + 1 modules
var SubscriberInput = __webpack_require__(56695);
// EXTERNAL MODULE: ./src/components/LogoutModal/index.js
var LogoutModal = __webpack_require__(21448);
// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(86812);
// EXTERNAL MODULE: ./src/utils/commonToggleAuthModal.js
var commonToggleAuthModal = __webpack_require__(13605);
// EXTERNAL MODULE: ./src/utils/removeDsAdsRouteLink.js
var removeDsAdsRouteLink = __webpack_require__(95218);
// EXTERNAL MODULE: ./src/utils/excuteLogout.js
var excuteLogout = __webpack_require__(85126);
// EXTERNAL MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody6/Hybrid.styles.js
var Hybrid_styles = __webpack_require__(43955);
;// CONCATENATED MODULE: ./src/components/DesignSystem/DigitalShowroomAds/HorizontalReasonModal.js



function HorizontalReasonModal(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex justify-between flew-row",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-column justify-center items-center left-section ml20px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex left-section-text-body f12px fw6",
                    children: [
                        "You are seeing this Ad ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "because owner of this ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "website using the free",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "version"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-column justify-center items-start pt20px pl20px pr20px right-section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex f12px fw6",
                        children: [
                            "If you own this website",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "then you can remove this"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex pa12px right-removead-section mt14px",
                        onClick: removeDsAdsRouteLink/* removeDsAdsRouteLink */.k,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex fw7",
                            children: "Remove this Ad"
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var DigitalShowroomAds_HorizontalReasonModal = (HorizontalReasonModal);

// EXTERNAL MODULE: ./src/components/DesignSystem/DigitalShowroomAds/ReasonModalHOC.js + 2 modules
var ReasonModalHOC = __webpack_require__(93992);
// EXTERNAL MODULE: ./src/utils/getCustomCtaText.js
var getCustomCtaText = __webpack_require__(36623);
// EXTERNAL MODULE: ./src/components/FooterMap/index.js + 2 modules
var FooterMap = __webpack_require__(76364);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(13886);
// EXTERNAL MODULE: ./src/components/DesignSystem/Footers/FooterStorePolicies/index.js
var FooterStorePolicies = __webpack_require__(81059);
// EXTERNAL MODULE: ./src/hooks/useFeatureLocks.js
var useFeatureLocks = __webpack_require__(27560);
// EXTERNAL MODULE: ./src/components/DesignSystem/Footers/footerUtils.js
var footerUtils = __webpack_require__(62371);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts
var ssrStore = __webpack_require__(20155);
// EXTERNAL MODULE: ./src/hooks/useStoreLogoOrNameVisibility.js
var useStoreLogoOrNameVisibility = __webpack_require__(73323);
// EXTERNAL MODULE: ./src/utils/getActualOrDsStoreLogo.js
var getActualOrDsStoreLogo = __webpack_require__(68491);
// EXTERNAL MODULE: ./src/utils/checkIfThemePreview.js
var checkIfThemePreview = __webpack_require__(15483);
// EXTERNAL MODULE: ./src/redux/actions/storePolicies.js
var actions_storePolicies = __webpack_require__(49784);
// EXTERNAL MODULE: ./src/hooks/useStoreContactDetails.tsx
var useStoreContactDetails = __webpack_require__(99375);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Footers/Footer/Footer.js

































var PremiumFooter = function(props) {
    var toggleLogoutModal = function toggleLogoutModal() {
        setShowLogoutConfirmation(!showLogoutConfirmation);
    };
    var renderSocialMediaProfileDetails = function renderSocialMediaProfileDetails(isMobileView) {
        var ref, ref1, ref2;
        if (!((ref = store.social_media_profile_details) === null || ref === void 0 ? void 0 : ref.media_count) || ((ref1 = store.social_media_profile_details) === null || ref1 === void 0 ? void 0 : ref1.media_count) < 1) return null;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "footer-social-media-container",
            style: isMobileView ? {} : {
                width: "246px"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Follow us here"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "social-media-section flex space-between",
                    style: {
                        gap: "16px"
                    },
                    children: (ref2 = store.social_media_profile_details) === null || ref2 === void 0 ? void 0 : ref2.media_detail.map(function(profile) {
                        return profile.profile_url !== "" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "social-media-icon",
                            style: {
                                height: "24px",
                                width: "24px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: profile.profile_url,
                                target: "_blank",
                                rel: "noreferrer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: profile.image_url,
                                    alt: "".concat(profile === null || profile === void 0 ? void 0 : profile.name, " image"),
                                    loading: "lazy"
                                })
                            })
                        }, profile.id) : null;
                    })
                })
            ]
        });
    };
    var renderLoginLogoutDesktop = function renderLoginLogoutDesktop() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "footer-login-logout",
                onClick: toggleAuthModal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "footer-login-logout-button fw5 pointer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        style: {
                            fontSize: 12
                        },
                        children: (user === null || user === void 0 ? void 0 : user.isLogin) ? "Logout" : "Login"
                    })
                })
            })
        });
    };
    var renderLoginLogoutMobile = function renderLoginLogoutMobile() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "footer-login-logout",
                onClick: toggleAuthModal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "footer-login-logout-button fw5 pointer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        style: {
                            fontSize: 12
                        },
                        children: (user === null || user === void 0 ? void 0 : user.isLogin) ? "Logout" : "Login"
                    })
                })
            })
        });
    };
    var authAndLogoutModal = function authAndLogoutModal() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: showLogoutConfirmation && /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoutModal["default"], {
                toggleLogoutModal: toggleLogoutModal,
                executeLogout: excuteLogout/* executeLogout */.q,
                showLogoutConfirmation: showLogoutConfirmation
            })
        });
    };
    var toggleAdReasonModal = function toggleAdReasonModal() {
        setShowAdInfo(!showAdInfo);
    };
    var renderDesktopAds = function renderDesktopAds() {
        var ref, ref1, ref2;
        return !isPreview && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: deviceWidth/* deviceWidth */.o > constants/* MAX_MOBILE_WIDTH */.Cf && ((ref = store.store_info) === null || ref === void 0 ? void 0 : ref.non_premium_ad_url_desktop_horizontal) && !(store === null || store === void 0 ? void 0 : (ref1 = store.theme) === null || ref1 === void 0 ? void 0 : ref1.is_demo) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Hybrid_styles/* AdContainer */.g1, {
                paddingTop: 0,
                paddingBottom: 42,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-column digital-showroom__ads-footer items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex footer-ads___width",
                            onClick: function() {
                                return setShowAdInfo(true);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex f8px o-50 mb6px black-90 f14px pointer",
                                    children: "Why I am seeing this"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "ml10px f10px pointer",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoIcon/* InfoIcon */.s, {
                                            size: 16,
                                            secondaryColor: "#7F7F7F"
                                        }),
                                        showAdInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReasonModalHOC/* default */.Z, {
                                            toggleAdReasonModal: toggleAdReasonModal,
                                            reasonModal: DigitalShowroomAds_HorizontalReasonModal,
                                            ml: -0.1,
                                            mt: -0.3,
                                            translateX: 0,
                                            translateY: 0,
                                            class: "horizontal-reason-modal mt8px"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex pointer items-start",
                            onClick: removeDsAdsRouteLink/* removeDsAdsRouteLink */.k,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: (ref2 = store.store_info) === null || ref2 === void 0 ? void 0 : ref2.non_premium_ad_url_desktop_horizontal,
                                width: 877,
                                height: 187
                            })
                        })
                    ]
                })
            }) : null
        });
    };
    var ref, ref1, ref2, ref3, ref4, ref5;
    var router = (0,next_router.useRouter)();
    var user = (0,es/* useSelector */.v9)(function(state) {
        return {
            user: state.userReducer
        };
    }).user;
    var ref6 = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            store: state.storeReducer.store,
            storePolicies: state.storePolicyReducer.data
        };
    }), store = ref6.store, storePolicies = ref6.storePolicies;
    var storePhone = (0,useStoreContactDetails/* default */.Z)().storePhone;
    var ref7 = (0,useFeatureLocks/* useFeatureLocks */.r)(), leadGenFeatureStatus = ref7.leadGenFeatureStatus, visitorLoginFeatureStatus = ref7.visitorLoginFeatureStatus;
    var isLeadGenVisible = leadGenFeatureStatus === null || leadGenFeatureStatus === void 0 ? void 0 : leadGenFeatureStatus.isVisible;
    var isVisitorLoginVisible = visitorLoginFeatureStatus === null || visitorLoginFeatureStatus === void 0 ? void 0 : visitorLoginFeatureStatus.isVisible;
    var ref8 = (0,react.useState)(""), sColor = ref8[0], setColor = ref8[1];
    var ref9 = (0,react.useState)(false), isDesktop = ref9[0], setIsDesktop = ref9[1];
    var ref10 = (0,react.useState)(false), isLoaded = ref10[0], setIsLoaded = ref10[1];
    var ref11 = (0,react.useState)({
        OSName: null,
        ownerNumber: null
    }), state = ref11[0], setState = ref11[1];
    var ref12 = (0,react.useState)(null), fullYear = ref12[0], setFullYear = ref12[1];
    var ref13 = (0,react.useState)(false), showLogoutConfirmation = ref13[0], setShowLogoutConfirmation = ref13[1];
    var ref14 = (0,react.useState)(false), showAdInfo = ref14[0], setShowAdInfo = ref14[1];
    var isPreview = (0,checkIfThemePreview/* default */.Z)();
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        var thisYear = new Date();
        setFullYear(thisYear.getFullYear());
        var OSName = (0,deviceInfo/* getDeviceInfo */.d)().OSName;
        setState(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                OSName: OSName,
                ownerNumber: storePhone
            });
        });
    }, [
        store
    ]);
    (0,react.useEffect)(function() {
        var ref, ref1;
        if (store === null || store === void 0 ? void 0 : (ref = store.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color) {
            var ref2, ref3;
            setColor((store === null || store === void 0 ? void 0 : store.premium) ? store === null || store === void 0 ? void 0 : (ref2 = store.theme) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.colors) === null || ref3 === void 0 ? void 0 : ref3.primary_color : "#000000");
        }
    }, [
        store === null || store === void 0 ? void 0 : (ref = store.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color
    ]);
    (0,react.useEffect)(function() {
        if (deviceWidth/* deviceWidth */.o > 766) {
            setIsDesktop(true);
        } else {
            setIsDesktop(false);
        }
        setIsLoaded(true);
    }, [
        deviceWidth/* deviceWidth */.o > 0
    ]);
    (0,react.useEffect)(function() {
        setShowLogoutConfirmation(false);
    }, [
        user === null || user === void 0 ? void 0 : user.isLogin
    ]);
    (0,react.useEffect)(function() {
        if ((store === null || store === void 0 ? void 0 : store.store_id) && !(storePolicies === null || storePolicies === void 0 ? void 0 : storePolicies.length)) {
            dispatch((0,actions_storePolicies/* getStorePolicies */.S)({
                store_id: store.store_id
            }));
        }
    }, [
        store === null || store === void 0 ? void 0 : store.store_id,
        storePolicies === null || storePolicies === void 0 ? void 0 : storePolicies.length
    ]);
    var toggleAuthModal = function() {
        var ref;
        if ((0,commonToggleAuthModal/* commonToggleAuthModal */.D)({
            userLogin: user === null || user === void 0 ? void 0 : user.isLogin,
            storeInfoDomain: store === null || store === void 0 ? void 0 : (ref = store.store_info) === null || ref === void 0 ? void 0 : ref.domain
        })) toggleLogoutModal();
    };
    var callNumber = function(e) {
        if (!((state.OSName === "Android" || state.OSName === "iPhone") && deviceWidth/* deviceWidth */.o < 766)) {
            e.preventDefault();
        }
    };
    return isLoaded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterContainer, {
        children: isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterDesktop, {
            callNumber: callNumber,
            authAndLogoutModal: authAndLogoutModal,
            renderLoginLogoutDesktop: renderLoginLogoutDesktop,
            renderDesktopAds: renderDesktopAds,
            router: router,
            noDescription: props.noDescription,
            store: store,
            sColor: sColor,
            fullYear: fullYear,
            renderSocialMediaProfileDetails: renderSocialMediaProfileDetails,
            storePolicies: storePolicies,
            showSubscriberInput: isLeadGenVisible,
            showVisitorLogin: isVisitorLoginVisible,
            isPaymentNotVisible: props === null || props === void 0 ? void 0 : (ref2 = props.config) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.hidden_components) === null || ref3 === void 0 ? void 0 : ref3.payment_method_images_not_visible
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterMobile, {
            callNumber: callNumber,
            authAndLogoutModal: authAndLogoutModal,
            renderLoginLogoutMobile: renderLoginLogoutMobile,
            router: router,
            noDescription: props.noDescription,
            store: store,
            sColor: sColor,
            fullYear: fullYear,
            storePolicies: storePolicies,
            renderSocialMediaProfileDetails: renderSocialMediaProfileDetails,
            showSubscriberInput: isLeadGenVisible,
            showVisitorLogin: isVisitorLoginVisible,
            isPaymentNotVisible: props === null || props === void 0 ? void 0 : (ref4 = props.config) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.hidden_components) === null || ref5 === void 0 ? void 0 : ref5.payment_method_images_not_visible
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
};
var FooterDesktop = function(param) {
    var store = param.store, sColor = param.sColor, noDescription = param.noDescription, router = param.router, callNumber = param.callNumber, fullYear = param.fullYear, authAndLogoutModal = param.authAndLogoutModal, renderLoginLogoutDesktop = param.renderLoginLogoutDesktop, showVisitorLogin = param.showVisitorLogin, renderDesktopAds = param.renderDesktopAds, renderSocialMediaProfileDetails = param.renderSocialMediaProfileDetails, storePolicies = param.storePolicies, showSubscriberInput = param.showSubscriberInput, isPaymentNotVisible = param.isPaymentNotVisible;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21;
    var dsLabel = (0,footerUtils/* getFooterDSLabel */.m)(store === null || store === void 0 ? void 0 : (ref = store.theme) === null || ref === void 0 ? void 0 : ref.components);
    var ref22 = (0,useStoreLogoOrNameVisibility/* default */.Z)(), isStoreLogoInFooter = ref22.isStoreLogoInFooter, isStoreNameInFooter = ref22.isStoreNameInFooter;
    var storeLogo = (0,getActualOrDsStoreLogo/* default */.Z)(store);
    var ref23 = (0,useStoreContactDetails/* default */.Z)(), storeAddress = ref23.storeAddress, storePhone = ref23.storePhone;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            authAndLogoutModal(),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterDesktopContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterDesktopMain, {
                        noAddress: (store === null || store === void 0 ? void 0 : (ref1 = store.address) === null || ref1 === void 0 ? void 0 : ref1.visibility) === 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StoreDescription, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StoreNameImage, {
                                        children: [
                                            storeLogo && isStoreLogoInFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreImage, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    alt: "store logo",
                                                    src: storeLogo
                                                })
                                            }),
                                            (store === null || store === void 0 ? void 0 : (ref2 = store.store_info) === null || ref2 === void 0 ? void 0 : ref2.name) && isStoreNameInFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreName, {
                                                children: store === null || store === void 0 ? void 0 : (ref3 = store.store_info) === null || ref3 === void 0 ? void 0 : ref3.name
                                            })
                                        ]
                                    }),
                                    !noDescription && (store === null || store === void 0 ? void 0 : (ref4 = store.store_info) === null || ref4 === void 0 ? void 0 : ref4.description) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StoreAboutUs, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLabel, {
                                                children: "About Us"
                                            }),
                                            !!(store === null || store === void 0 ? void 0 : (ref5 = store.store_info) === null || ref5 === void 0 ? void 0 : ref5.description) && (store === null || store === void 0 ? void 0 : (ref6 = store.store_info) === null || ref6 === void 0 ? void 0 : ref6.description.length) > 160 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterPara, {
                                                textSelection: true,
                                                children: [
                                                    store === null || store === void 0 ? void 0 : (ref7 = store.store_info) === null || ref7 === void 0 ? void 0 : ref7.description.substr(0, 155),
                                                    "..."
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterPara, {
                                                textSelection: true,
                                                needLineClip: true,
                                                children: store === null || store === void 0 ? void 0 : (ref8 = store.store_info) === null || ref8 === void 0 ? void 0 : ref8.description
                                            }),
                                            (store === null || store === void 0 ? void 0 : (ref9 = store.store_info) === null || ref9 === void 0 ? void 0 : ref9.description.length) > 160 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewMoreText, {
                                                onClick: function() {
                                                    var ref;
                                                    router.push((0,routes.getRoute)(routes.PATH.ABOUT_US, store === null || store === void 0 ? void 0 : (ref = store.store_info) === null || ref === void 0 ? void 0 : ref.domain));
                                                },
                                                children: "View More"
                                            })
                                        ]
                                    }),
                                    showVisitorLogin && renderLoginLogoutDesktop()
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StoreDetails, {
                                noAddress: (store === null || store === void 0 ? void 0 : (ref10 = store.address) === null || ref10 === void 0 ? void 0 : ref10.visibility) === 2,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
                                        children: storePhone && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLabel, {
                                                    children: "Contact us"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterButton, {
                                                    color: sColor || (store === null || store === void 0 ? void 0 : (ref11 = store.store_info) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.theme) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.colors) === null || ref13 === void 0 ? void 0 : ref13.primary_color),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                        href: "tel:".concat(storePhone),
                                                        onClick: callNumber,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "footer-button-phone-icon",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneIcon/* PhoneIcon */.q, {
                                                                    color: sColor || (store === null || store === void 0 ? void 0 : (ref14 = store.store_info) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.theme) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.colors) === null || ref16 === void 0 ? void 0 : ref16.primary_color),
                                                                    size: 12
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneNumber, {
                                                                color: sColor || (store === null || store === void 0 ? void 0 : (ref17 = store.store_info) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.theme) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.colors) === null || ref19 === void 0 ? void 0 : ref19.primary_color),
                                                                children: storePhone
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    showSubscriberInput ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscriberInput/* default */.Z, {})
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
                                        children: storeAddress && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLabel, {
                                                    children: "Visit Us"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterPara, {
                                                    children: storeAddress
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
                                        children: (store === null || store === void 0 ? void 0 : store.social_media_profile_details) && renderSocialMediaProfileDetails(false)
                                    }),
                                    !isPaymentNotVisible && !(store === null || store === void 0 ? void 0 : (ref20 = store.services) === null || ref20 === void 0 ? void 0 : ref20.delivery_time_approx) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                                        style: {
                                            display: "none"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLabel, {
                                                children: (0,getCustomCtaText/* default */.Z)("pay_after_cta")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentRow, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentOption, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: "/assets/images/ic_paytm@2x.png",
                                                            alt: "Paytm",
                                                            height: 31,
                                                            width: 63,
                                                            layout: "fixed"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentOption, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: "/assets/images/ic_gpay@2x.png",
                                                            alt: "GPay",
                                                            height: 27,
                                                            width: 57,
                                                            layout: "fixed"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentOption, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: "/assets/images/ic_phonep@2x.png",
                                                            alt: "Phonpe",
                                                            height: 25,
                                                            width: 25,
                                                            layout: "fixed"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentOption, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentCash, {
                                                            children: "Or Cash"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterMap/* FooterMap */.sy, {
                                storeData: store
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterStorePolicies/* FooterStorePolicies */.p, {
                        storePolicies: storePolicies,
                        path: routes.PATH.STORE_POLICIES
                    }),
                    renderDesktopAds(),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterTrademarkComponent, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterTrademark, {
                                children: [
                                    "Copyright ",
                                    fullYear,
                                    dsLabel ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            ". ",
                                            dsLabel
                                        ]
                                    }) : "",
                                    " | "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterTrademark, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        target: "_blank",
                                        href: constants/* CANCELATION_AND_REFUND_POLICY_URL */.a6,
                                        rel: "noreferrer",
                                        children: "Refunds & Cancellation"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Circle, {}),
                                    (store === null || store === void 0 ? void 0 : (ref21 = store.services) === null || ref21 === void 0 ? void 0 : ref21.delivery_time_approx) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        target: "_blank",
                                        href: constants/* DS_TERMS_AND_CONDITIONS_URL */.gl,
                                        rel: "noreferrer",
                                        children: "Terms & Conditions"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        target: "_blank",
                                        href: constants/* DS_TERMS_AND_CONDITIONS_URL */.gl,
                                        rel: "noreferrer",
                                        children: "Terms & Conditions"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var FooterMobile = function(param) {
    var store = param.store, sColor = param.sColor, noDescription = param.noDescription, router = param.router, callNumber = param.callNumber, fullYear = param.fullYear, authAndLogoutModal = param.authAndLogoutModal, renderLoginLogoutMobile = param.renderLoginLogoutMobile, showVisitorLogin = param.showVisitorLogin, renderSocialMediaProfileDetails = param.renderSocialMediaProfileDetails, storePolicies = param.storePolicies, showSubscriberInput = param.showSubscriberInput, isPaymentNotVisible = param.isPaymentNotVisible;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19;
    var dsLabel = (0,footerUtils/* getFooterDSLabel */.m)(store === null || store === void 0 ? void 0 : (ref = store.theme) === null || ref === void 0 ? void 0 : ref.components);
    var ref20 = (0,useStoreLogoOrNameVisibility/* default */.Z)(), isStoreLogoInFooter = ref20.isStoreLogoInFooter, isStoreNameInFooter = ref20.isStoreNameInFooter;
    var storeLogo = (0,getActualOrDsStoreLogo/* default */.Z)(store);
    var ref21 = (0,useStoreContactDetails/* default */.Z)(), storeAddress = ref21.storeAddress, storePhone = ref21.storePhone;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            authAndLogoutModal(),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterMobileContainer, {
                children: [
                    !isPaymentNotVisible && !(store === null || store === void 0 ? void 0 : (ref1 = store.services) === null || ref1 === void 0 ? void 0 : ref1.delivery_time_approx) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                        display: "flex",
                        style: {
                            display: "none"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLabel, {
                                style: {
                                    flex: 0.9
                                },
                                children: (0,getCustomCtaText/* default */.Z)("pay_after_cta")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentRow, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentOption, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: "/assets/images/ic_paytm@2x.png",
                                            alt: "Paytm",
                                            height: 31,
                                            width: 63,
                                            layout: "fixed"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentOption, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: "/assets/images/ic_gpay@2x.png",
                                            alt: "GPay",
                                            height: 27,
                                            width: 57,
                                            layout: "fixed"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentOption, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: "/assets/images/ic_phonep@2x.png",
                                            alt: "Phonpe",
                                            height: 25,
                                            width: 25,
                                            layout: "fixed"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentOption, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentCash, {
                                            children: "Or Cash"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterMobileMain, {
                        children: [
                            showSubscriberInput ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscriberInput/* default */.Z, {})
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StoreDescription, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StoreNameImage, {
                                        children: [
                                            storeLogo && isStoreLogoInFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreImage, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    loading: "lazy",
                                                    alt: "Store Logo",
                                                    src: storeLogo
                                                })
                                            }),
                                            (store === null || store === void 0 ? void 0 : (ref2 = store.store_info) === null || ref2 === void 0 ? void 0 : ref2.name) && isStoreNameInFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreName, {
                                                children: store === null || store === void 0 ? void 0 : (ref3 = store.store_info) === null || ref3 === void 0 ? void 0 : ref3.name
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                                        children: [
                                            showVisitorLogin && renderLoginLogoutMobile(),
                                            storePhone && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLabel, {
                                                        children: "Contact us"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterButton, {
                                                        color: sColor || (store === null || store === void 0 ? void 0 : (ref4 = store.store_info) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.theme) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.colors) === null || ref6 === void 0 ? void 0 : ref6.primary_color),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                            href: "tel:".concat(storePhone),
                                                            onClick: callNumber,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "footer-button-phone-icon",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneIcon/* PhoneIcon */.q, {
                                                                        size: 11,
                                                                        color: sColor || (store === null || store === void 0 ? void 0 : (ref7 = store.store_info) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.theme) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.colors) === null || ref9 === void 0 ? void 0 : ref9.primary_color)
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneNumber, {
                                                                    color: sColor || (store === null || store === void 0 ? void 0 : (ref10 = store.store_info) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.theme) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.colors) === null || ref12 === void 0 ? void 0 : ref12.primary_color),
                                                                    children: storePhone
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    !noDescription && (store === null || store === void 0 ? void 0 : (ref13 = store.store_info) === null || ref13 === void 0 ? void 0 : ref13.description) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StoreAboutUs, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLabel, {
                                                children: "About Us"
                                            }),
                                            (store === null || store === void 0 ? void 0 : (ref14 = store.store_info) === null || ref14 === void 0 ? void 0 : ref14.description) && (store === null || store === void 0 ? void 0 : (ref15 = store.store_info) === null || ref15 === void 0 ? void 0 : ref15.description.length) > 160 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterPara, {
                                                textSelection: true,
                                                children: [
                                                    store === null || store === void 0 ? void 0 : (ref16 = store.store_info) === null || ref16 === void 0 ? void 0 : ref16.description.substr(0, 155),
                                                    "..."
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterPara, {
                                                textSelection: true,
                                                needLineClip: true,
                                                children: store === null || store === void 0 ? void 0 : (ref17 = store.store_info) === null || ref17 === void 0 ? void 0 : ref17.description
                                            }),
                                            (store === null || store === void 0 ? void 0 : (ref18 = store.store_info) === null || ref18 === void 0 ? void 0 : ref18.description.length) > 160 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewMoreText, {
                                                onClick: function() {
                                                    var ref;
                                                    router.push((0,routes.getRoute)(routes.PATH.ABOUT_US, store === null || store === void 0 ? void 0 : (ref = store.store_info) === null || ref === void 0 ? void 0 : ref.domain));
                                                },
                                                children: "View More"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
                                        children: (store === null || store === void 0 ? void 0 : store.social_media_profile_details) && renderSocialMediaProfileDetails(true)
                                    })
                                ]
                            }),
                            !!storeAddress && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreDetails, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLabel, {
                                                    children: "Visit Us"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterPara, {
                                                    children: storeAddress
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterMap/* FooterMap */.sy, {
                                        storeData: store
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterStorePolicies/* FooterStorePolicies */.p, {
                        storePolicies: storePolicies,
                        path: routes.PATH.STORE_POLICIES
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterTrademarkComponent, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterTrademark, {
                                children: [
                                    "Copyright ",
                                    fullYear,
                                    dsLabel ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            ". ",
                                            dsLabel
                                        ]
                                    }) : ""
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterTrademark, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: constants/* CANCELATION_AND_REFUND_POLICY_URL */.a6,
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: "Refunds & Cancellation"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Circle, {}),
                                    (store === null || store === void 0 ? void 0 : (ref19 = store.services) === null || ref19 === void 0 ? void 0 : ref19.delivery_time_approx) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: constants/* DS_TERMS_AND_CONDITIONS_URL */.gl,
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: "Terms & Conditions"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: constants/* DS_TERMS_AND_CONDITIONS_URL */.gl,
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: "Terms & Conditions"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Footer = (PremiumFooter);


/***/ }),

/***/ 81059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ FooterStorePolicies; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86438);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_handleRouteChangesOnClick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79570);




var FooterStorePolicies = function(props) {
    return !props.storePolicies || props.storePolicies.length == 0 ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().bottom_section), " flex flex-column items-center"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().store_policies), " flex justify-around w-100 f6"),
            children: props === null || props === void 0 ? void 0 : props.storePolicies.map(function(page) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    name: "page".concat(page.page_type),
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().footer_nav),
                    onClick: function() {
                        return (0,_utils_handleRouteChangesOnClick__WEBPACK_IMPORTED_MODULE_2__/* .handleRouteChangesOnClick */ .Z)(props === null || props === void 0 ? void 0 : props.path, {
                            page_type: page.page_type
                        });
                    },
                    children: page.page_name
                }, page.id);
            })
        })
    });
};


/***/ }),

/***/ 43955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ ListingHeading; },
/* harmony export */   "W2": function() { return /* binding */ Container; },
/* harmony export */   "X6": function() { return /* binding */ Heading; },
/* harmony export */   "Z5": function() { return /* binding */ AllCategorySection; },
/* harmony export */   "bu": function() { return /* binding */ AllCategoryButton; },
/* harmony export */   "g1": function() { return /* binding */ AdContainer; },
/* harmony export */   "rV": function() { return /* binding */ MiddleBodyAdWrapper; }
/* harmony export */ });
/* unused harmony export Listing */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50066);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: ",
        ";\n  width: ",
        ";\n  display: flex;\n  max-width: 1600px;\n  flex-direction: column;\n  height: auto;\n  box-sizing: border-box;\n  position: relative;\n  margin: 0 auto;\n  ",
        "\n  @media screen and (max-width: 767px) {\n    padding-top: 0;\n    width: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  width: 100%;\n  font-size: 40px;\n  color: ",
        ";\n\n  @media screen and (min-width: 767px) {\n    font-size: 40px;\n    margin-bottom: 3rem;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 28px;\n    margin-bottom: 2rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  max-width: 1000px;\n  display: grid;\n  grid-template-rows: auto;\n  justify-items: center;\n  box-sizing: border-box;\n  margin-bottom: 3rem;\n\n  @media screen and (min-width: 767px) {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    row-gap: 2rem;\n    column-gap: 1.5rem;\n    padding: 0 2rem;\n  }\n\n  @media screen and (max-width: 766px) {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    row-gap: 1.5rem;\n    column-gap: 1rem;\n    padding: 0 1rem;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: #000000;\n  font-weight: 600;\n  margin-bottom: 0.8rem;\n\n  @media screen and (min-width: 767px) {\n    font-size: 28px;\n    padding: 0 0;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 20px;\n    padding: 0 20px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  position: sticky;\n  bottom: 5%;\n  z-index: 5;\n  background: transparent;\n  width: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  border-radius: 30px;\n  box-shadow: 0px 16px 36px #0000004a;\n  background: ",
        " 0% 0% no-repeat padding-box;\n  color: ",
        ";\n  cursor: pointer;\n\n  @media screen and (min-width: 767px) {\n    font-size: 18px;\n    padding: 16px 40px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 14px;\n    padding: 14px 16px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  grid-column-start: 1;\n  grid-column-end: 3;\n  background: ",
        ";\n  padding-top: ",
        "px;\n  padding-bottom: ",
        "px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: row;\n  background: #fff;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}

function slideInAnimate() {
    return "\n    animation-name: slide-in;\n    animation-duration: 0.5s;\n    transform : translateX(50px);\n\n    @keyframes slide-in {\n      from {\n          transform : translateX(0px);\n      }\n      to {\n          transform : translateX(50px);\n      }\n    }\n    ";
}
function slideOutAnimate(trasnlationDist) {
    return "\n    animation-name: slide-out;\n    animation-duration: 0.50s;\n\n    @keyframes slide-out {\n      from {\n          transform : translateX(50px);\n      }\n      to {\n        transform : translateX(-".concat(trasnlationDist - 50, "px);\n      }\n    }\n    ");
}
var Container = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].article.withConfig */ .ZP.article.withConfig({
    displayName: "Container",
    componentId: "sc-81fe99c9-0"
})(_templateObject(), function(props) {
    return props.isBuilderMobile ? "4rem 16px 2rem" : "4rem 0 2rem";
}, function(props) {
    return props.isBuilderMobile ? "100%" : "80%";
}, function(props) {
    return props.showFilterDrawer === null ? "" : props.showFilterDrawer ? slideInAnimate() : slideOutAnimate(props.trasnlationDist);
});
var Heading = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
    displayName: "Heading",
    componentId: "sc-81fe99c9-1"
})(_templateObject1(), function(props) {
    return props.fontColor || "#000000";
});
var Listing = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "Listing",
    componentId: "sc-81fe99c9-2"
})(_templateObject2());
var ListingHeading = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
    displayName: "ListingHeading",
    componentId: "sc-81fe99c9-3"
})(_templateObject3());
var AllCategorySection = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "AllCategorySection",
    componentId: "sc-81fe99c9-4"
})(_templateObject4());
var AllCategoryButton = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "AllCategoryButton",
    componentId: "sc-81fe99c9-5"
})(_templateObject5(), function(props) {
    return props.backgroundColor || "#ffffff";
}, function(props) {
    return props.backgroundColor ? "#ffffff" : "#000000";
});
var AdContainer = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "AdContainer",
    componentId: "sc-81fe99c9-6"
})(_templateObject6(), function(props) {
    return props.backgroundColor || "#FFFFFF";
}, function(props) {
    return props.paddingTop || 0;
}, function(props) {
    return props.paddingBottom || 0;
});
var MiddleBodyAdWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "MiddleBodyAdWrapper",
    componentId: "sc-81fe99c9-7"
})(_templateObject7());


/***/ }),

/***/ 36623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24686);
/* harmony import */ var _utils_getStoreType__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66871);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13886);



/** This utility function returns custom cta texts, certain labels based on is the store deliverying orders or
 * booking services
 * @param {string} type -> type of text you want
 * @return {string} -> text you wanted
 */ var getCustomCtaText = function(type) {
    var _store = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().storeReducer.store, theme = _store.theme, services = _store.services;
    var isStoreServiceBased = (0,_utils_getStoreType__WEBPACK_IMPORTED_MODULE_1__/* .getStoreType */ .K)() !== _constants__WEBPACK_IMPORTED_MODULE_2__/* .STORE_CUSTOMIZATION.ORDER_BASED */ .DO.ORDER_BASED && (0,_utils_getStoreType__WEBPACK_IMPORTED_MODULE_1__/* .getStoreType */ .K)() != _constants__WEBPACK_IMPORTED_MODULE_2__/* .STORE_CUSTOMIZATION.B2B */ .DO.B2B;
    var isExtraChargeForCODActive = (services === null || services === void 0 ? void 0 : services.cod_charge_flag) > _constants__WEBPACK_IMPORTED_MODULE_2__/* .COD_CHARGE_TYPE.FREE */ .VV.FREE;
    var getBillConfirmedHeading = function() {
        switch((0,_utils_getStoreType__WEBPACK_IMPORTED_MODULE_1__/* .getStoreType */ .K)()){
            case _constants__WEBPACK_IMPORTED_MODULE_2__/* .STORE_CUSTOMIZATION.ORDER_BASED */ .DO.ORDER_BASED:
                return "Order placed successfully!";
            case _constants__WEBPACK_IMPORTED_MODULE_2__/* .STORE_CUSTOMIZATION.B2B */ .DO.B2B:
                return "Request submitted Successfully";
            default:
                return "Booked Successfully";
        }
    };
    var getBillOrderIdLabel = function() {
        var cart = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().cartReducer;
        switch(cart.order_type){
            case _constants__WEBPACK_IMPORTED_MODULE_2__/* .ORDER_TYPE.SERVICE */ .Jm.SERVICE:
                return "Your Booking ID:";
            case _constants__WEBPACK_IMPORTED_MODULE_2__/* .ORDER_TYPE.B2B */ .Jm.B2B:
                return "Your Request ID:";
            default:
                return "Your Order ID:";
        }
    };
    switch(type){
        case "my_orders_cta":
            var ref, ref1;
            if ((0,_utils_getStoreType__WEBPACK_IMPORTED_MODULE_1__/* .getStoreType */ .K)() === _constants__WEBPACK_IMPORTED_MODULE_2__/* .STORE_CUSTOMIZATION.B2B */ .DO.B2B) return "My Requests";
            else if (theme === null || theme === void 0 ? void 0 : (ref = theme.cta_config) === null || ref === void 0 ? void 0 : ref.my_orders) return theme === null || theme === void 0 ? void 0 : (ref1 = theme.cta_config) === null || ref1 === void 0 ? void 0 : ref1.my_orders;
            else if (isStoreServiceBased) return "My Bookings";
            else return "My Orders";
        case "bill_confirm_heading":
            return getBillConfirmedHeading();
        case "placing_order_cta":
            if (isStoreServiceBased) return "Booking your Service";
            else return "Placing Your Order";
        case "buy_now_cta":
            var ref2, ref3;
            if (theme === null || theme === void 0 ? void 0 : (ref2 = theme.cta_config) === null || ref2 === void 0 ? void 0 : ref2.pdp_cta) return theme === null || theme === void 0 ? void 0 : (ref3 = theme.cta_config) === null || ref3 === void 0 ? void 0 : ref3.pdp_cta;
            else if (isStoreServiceBased) return "Book Now";
            else "Buy NOW";
        case "empty_cart_cta":
            return isStoreServiceBased ? "Book Now" : "Shop Now";
        case "banner_cta":
            var ref4, ref5;
            if ((0,_utils_getStoreType__WEBPACK_IMPORTED_MODULE_1__/* .getStoreType */ .K)() === _constants__WEBPACK_IMPORTED_MODULE_2__/* .STORE_CUSTOMIZATION.B2B */ .DO.B2B) return "My Requests";
            else if (theme === null || theme === void 0 ? void 0 : (ref4 = theme.cta_config) === null || ref4 === void 0 ? void 0 : ref4.banner_cta) return theme === null || theme === void 0 ? void 0 : (ref5 = theme.cta_config) === null || ref5 === void 0 ? void 0 : ref5.banner_cta;
            else if (isStoreServiceBased) return "Book Now";
            else return "Shop Now";
        case "order_instructions_label":
            if (isStoreServiceBased) return "Booking Instructions";
            else return "Order Instructions";
        case "cart_cta":
            var ref6, ref7;
            if (theme === null || theme === void 0 ? void 0 : (ref6 = theme.cta_config) === null || ref6 === void 0 ? void 0 : ref6.postpaid_cart_cta) return theme === null || theme === void 0 ? void 0 : (ref7 = theme.cta_config) === null || ref7 === void 0 ? void 0 : ref7.postpaid_cart_cta;
            else if (isStoreServiceBased) return "Book Now";
            else return "Place Order";
        case "item_total_label":
            if (isStoreServiceBased) return "Total";
            else return "Item Total";
        case "order_summary_heading":
            if (isStoreServiceBased) return "Summary";
            else return "Order Summary";
        case "item_details_heading":
            if (isStoreServiceBased) return "Details";
            else return "Item Details";
        case "widget_cta":
            if (isStoreServiceBased) return "Book Now";
            else return "Explore Now";
        case "cart_confirm_cta":
            {
                var cart = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().cartReducer;
                var isOrderServiceType = cart.order_type === _constants__WEBPACK_IMPORTED_MODULE_2__/* .ORDER_TYPE.SERVICE */ .Jm.SERVICE;
                if (isOrderServiceType) return "Pay after service";
                else if (cart.order_type === _constants__WEBPACK_IMPORTED_MODULE_2__/* .ORDER_TYPE.DELIVERY */ .Jm.DELIVERY) return isExtraChargeForCODActive ? "Cash On Delivery" : "Pay On Delivery";
                else return "Pay on Pickup";
            }
        case "pay_after_cta":
            if (isStoreServiceBased) return "Pay after Service using";
            else return "Pay on Delivery / Pickup using";
        case "other_payment_modes_cta":
            if (isStoreServiceBased) return "Pay after service";
            else {
                var _orderDetails = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().orderReducer.orderDetails, prepaid_flag = _orderDetails.prepaid_flag, order_type = _orderDetails.order_type;
                if (prepaid_flag === 1) {
                    if (order_type === _constants__WEBPACK_IMPORTED_MODULE_2__/* .ORDER_TYPE.DELIVERY */ .Jm.DELIVERY) return isExtraChargeForCODActive ? "Cash On Delivery" : "Pay On Delivery";
                    else return "Pay On Pick Up";
                } else return "Cash On Delivery";
            }
        case "bill_order_id":
            {
                return getBillOrderIdLabel();
            }
        case "order_list_heading":
            return isStoreServiceBased ? "My Bookings" : "My Orders";
        default:
            return "";
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (getCustomCtaText);


/***/ }),

/***/ 95218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ removeDsAdsRouteLink; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13886);

function removeDsAdsRouteLink() {
    window.open(_constants__WEBPACK_IMPORTED_MODULE_0__/* .REDIRECT_DS_ADS_LINK.COMMON_REDIRECTION_LINK */ .gr.COMMON_REDIRECTION_LINK, "_blank");
}


/***/ }),

/***/ 86438:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bottom_section":"FooterStorePolicies_bottom_section__Q64j2","footer__bottom-text":"FooterStorePolicies_footer__bottom-text__Cfylc","policy-nav":"FooterStorePolicies_policy-nav__u8EJg","store_policies":"FooterStorePolicies_store_policies__hE_9r","footer_nav":"FooterStorePolicies_footer_nav__DLmtJ"};

/***/ })

}]);